<!--
 * @Description: 元件modal
 * @Date: 2022-03-08 11:29:58
 * @LastEditTime: 2023-05-11 15:41:39
-->
<template>
  <div>
    <a-tabs v-model:activeKey="currentTab">
      <a-tab-pane key="1" tab="属性">
        <TabProperty :data="propertyVos" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="指令">
        <TabCommand :data="commandVos" />
      </a-tab-pane>
      <a-tab-pane key="3" tab="事件">
        <TabEvent :data="eventVos" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";
import TabProperty from "./tab-property.vue";
import TabEvent from "./tab-event.vue";
import TabCommand from "./tab-command.vue";
import {
  getStandardMembersByVerId,
  getCustomMembersByVerId
} from "@/api/console/model/model-definition";
export default defineComponent({
  props: {
    record: Object,
    namespace: {
      type: String,
      default: "standard"
    }
  },
  setup(props) {
    let currentTab = ref("1");
    let commandVos = ref([]);
    let eventVos = ref([]);
    let propertyVos = ref([]);
    const getList = () => {
      const request =
        props.namespace === "custom"
          ? getCustomMembersByVerId(props.record.id)
          : getStandardMembersByVerId(props.record.functionVer.id);
      request.then((res) => {
        commandVos.value = res.data.commandVos;
        eventVos.value = res.data.eventVos;
        propertyVos.value = res.data.propertyVos;
      });
    };

    getList();

    return { commandVos, eventVos, propertyVos, currentTab };
  },
  components: {
    TabProperty,
    TabEvent,
    TabCommand
  }
});
</script>
